<template>
  <tbody v-if="rating">
    <tr :key="rating.Name" @click="showDetail = !showDetail">
      <td>{{ $t(translationPrefix + rating.Name)}}</td>
      <td>{{rating.Value}}{{valueSymbol}}</td>
      <td>
        <font-awesome-icon
          v-if="rating.Message_Text"
          :icon="['fas', showDetail ? 'chevron-down' : 'chevron-right' ]"></font-awesome-icon>
      </td>
    </tr>
    <tr v-if="showDetail && rating.Message_Text" :key="rating.Name + 'message'">
      <td class="bg-light p-3" colspan="4">
        <h5>{{ $t(translationPrefix + rating.Name)}}</h5>
        <div v-html="rating.Message_Text"></div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import AccomplishmentIcon from "@/components/Shared/AccomplishmentIcon";

export default {
  name: "CompetitorRatingTableRow",
  components: {
    AccomplishmentIcon
  },
  props: {
    rating: Object,
    valueSymbol: String,
    translationPrefix: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      showDetail: false
    }
  }
}
</script>
